//@ts-check
import React, { useEffect, useState } from "react"
import StepHeader from "./step-header"
import ValueOrChoose from "./value-or-choose"
import store from "../store"
import BlockEdit from "./block-edit"
import StyleWrapper from "src/utils/stylesWrapper"
import useIsLoggedIn from "src/utils/use-is-logged-in"
import { CircularProgress } from "@material-ui/core"
import { useStepIndex } from "./step-index-context"

export default function CheckBalanceStep() {
  const { isLoggedIn } = useIsLoggedIn();
  const [showDescrtionInput, setShowDescrtionInput] = useState(false);
  const [savingSimulation, setSavingSimulation] = useState(false);

  var stepIndex=useStepIndex()
  useEffect(() => {
    if (store.steps[stepIndex].description && !showDescrtionInput) {
      setShowDescrtionInput(true);
    }
  }, [store.steps[stepIndex].description]);

  return (
    <StyleWrapper>
      <StepHeader />
      <div css="background: white; padding: 0px 20px 5px 10px">
        <>        
          {
            // @ts-ignore
            isLoggedIn && store.userIsAllowed(isLoggedIn?.email) &&
            <>
              {
                showDescrtionInput ?
                  <div css="
                    margin-top: 0px">
                    <ValueOrChoose
                      label="Description"
                      disabled={store.isStepReadOnly(stepIndex) || store.steps[stepIndex]['defaultStep']}
                      labelBackground="white"
                      hint=""
                      hideType
                      type="multilinetext"
                      value={store.steps[stepIndex].description}
                      onChange={v => {                        
                        store.steps[stepIndex].description = v; 
                        store.updateStore()
                      }}
                    /> </div> :

                  <>
                    {
                      (!store.isStepReadOnly(stepIndex) && !store.steps[stepIndex]['defaultStep']) ?
                        <div css="
                  margin-top: 20px;
                  color:#799fd4;
                  cursor: pointer;
                  text-decoration-line: underline;" onClick={() => { setShowDescrtionInput(true) }}>Add description</div> : null
                    }
                  </>

              }
            </>
          }

        </>

        <div css="
          margin-top: 20px;">
          <ValueOrChoose
            label="Address"
            // @ts-ignore
            labelBackground="white"
            disabled={store.isStepReadOnly(stepIndex) || store.steps[stepIndex]['defaultStep']}
            hideType
            type="address"
            value={store.steps[stepIndex].to}
            onChange={v => {
              store.steps[stepIndex].to = v
              store.removeResults(stepIndex);
              store.updateStore()
            }}
          />
        </div>

        {false && <div css="
          margin-top: 20px">
          <BlockEdit />
        </div>}
      </div>
    </StyleWrapper>
  )
}
